// extracted by mini-css-extract-plugin
export default {"root":"WeekSelectPure_root__2-rog","arrBtn":"WeekSelectPure_arrBtn__uHktU","icon":"WeekSelectPure_icon__qXL53"};